export const PICKUPS = 'pickups';
